import React from 'react';
import { Button } from '@material-ui/core';
import NotesIcon from '@material-ui/icons/Note';
import AccountIcon from '@material-ui/icons/AccountCircle';
import SignOutIcon from '@material-ui/icons/ExitToApp';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

const TopBarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  border-radius: 10px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  margin-left: 10px;
  color: #333;
  text-transform: none;
  display: flex;
  align-items: center;

  .icon {
    margin-right: 5px;
  }
`;

const TopBar = inject('userStore', 'routerStore')(observer(({ userStore }) => {
  const handleSignOut = () => {
    userStore.signout();
    window.location.hash = '/signin';
  };

  return (
    <TopBarContainer>
      <div>
        <StyledButton onClick={() => { window.location.hash = '/notes'; }}>
          <NotesIcon className="icon" /> Notes
        </StyledButton>
        <StyledButton onClick={() => { window.location.hash = '/account'; }}>
          <AccountIcon className="icon" /> Account
        </StyledButton>
      </div>
      <IconContainer>
        <StyledButton onClick={handleSignOut}>
          <SignOutIcon className="icon" /> Sign Out
        </StyledButton>
      </IconContainer>
    </TopBarContainer>
  );
}));

export default TopBar;
